<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text">
          <div class="name">我的PK</div>
          <div>
            累计获得积分：{{ pkData.integral || 0 }} ，金额
            {{ pkData.jine || 0 }}
          </div>
        </div>
        <div class="pictrue">
          <img
            src="@assets/images/pk1.png"
            @click="$router.replace({ path: '/user/pk/pk_add' })"
          />
        </div>
      </div>
    </div>
    <div class="nav acea-row row-around">
      <div
        class="item"
        :class="{ on: type === 0 }"
        @click="$router.replace({ path: '/user/pk/0' })"
      >
        <div>全部</div>
        <div class="num">{{ pkData.all_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 1 }"
        @click="$router.replace({ path: '/user/pk/1' })"
      >
        <div>我发起</div>
        <div class="num">{{ pkData.send_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 2 }"
        @click="$router.replace({ path: '/user/pk/2' })"
      >
        <div>我收到</div>
        <div class="num">{{ pkData.receive_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 3 }"
        @click="$router.replace({ path: '/user/pk/3' })"
      >
        <div>PK中</div>
        <div class="num">{{ pkData.pking_count || 0 }}</div>
      </div>
      <div
        class="item"
        :class="{ on: type === 4 }"
        @click="$router.replace({ path: '/user/pk/4' })"
      >
        <div>已完成</div>
        <div class="num">{{ pkData.complete_count || 0 }}</div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="pk in pkList" :key="pk.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span class="sign cart-color acea-row row-center-wrapper">{{
              pk.myRole
            }}</span>
            {{ pk.s_nickname }} <i class="font-color-red dpvs"> vs </i>
            {{ pk.r_nickname }}
          </div>
          <div class="font-color-red">{{ pk.status_txt }}</div>
        </div>
        <div>
          <div class="item-info acea-row row-between row-top">
            <div
              class=" acea-row row-between dp_userpk"
              :style="{ width: '100%' }"
            >
              <div class="line2">
                PK月份：{{ pk.starttime }}，筹码类型：{{
                  getChiptype(pk.chip_type)
                }}
              </div>

              <div
                class="dp_pk_com_item"
                v-if="
                  (pk.status == 2 || pk.status == 3 || pk.status == 4) &&
                    (pk.s_salse > 0 || pk.r_salse > 0)
                "
              >
                <div class="dp_pk_com_jindu">
                  <div
                    class="dp_pk_jindu_l"
                    :class="getLKing(pk)"
                    :style="getLeftWidth(pk)"
                  >
                    <span>￥{{ pk.s_salse }}</span
                    ><img src="../../../assets/images/shengfang.png" />
                  </div>
                  <div
                    class="dp_pk_jindu_r"
                    :class="getRKing(pk)"
                    :style="getRightWidth(pk)"
                  >
                    <span>￥{{ pk.r_salse }}</span
                    ><img src="../../../assets/images/shengfang.png" />
                  </div>
                </div>
                <!-- <div class="dp_pk_com_des">
                  <span v-if="pk.status == 4"
                    >胜方：{{ getWinner(pk) }}，获得筹码{{ pk.chip * 2 }}</span
                  >
                  <span v-if="pk.status == 2 || pk.status == 3"
                    >胜方将获得获得全部筹码{{ pk.chip * 2 }}</span
                  >
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          筹码：<span class="money font-color-red">{{ getChip(pk) }}</span>
        </div>
        <div
          class="bottom acea-row row-right row-middle"
          v-if="pk.showbtn == 1"
        >
          <template>
            <div class="bnt cancelBnt" @click="delPk(pk)" v-if="pk.delbtn == 1">
              删除
            </div>
            <!-- <div class="bnt cancelBnt" @click="delPk(pk)" v-if="pk.delbtn == 1">
              修改
            </div> -->
            <div
              class="bnt bg-color-red"
              @click="acceptTap(pk)"
              v-if="pk.acceptbtn == 1"
            >
              立即接受
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="noCart" v-if="pkList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getPkData, getPkUserList } from "@api/user";
import { cancelPkHandle, acceptPkHandle } from "@libs/pk";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";
//const STATUS = ["全部", "我发起", "我收到", "PK中", "已完成"];
const NAME = "UserPk";
export default {
  name: NAME,
  data() {
    return {
      pkData: {},
      type: parseInt(this.$route.params.type) || 0, //标签切换0-全部，1-我发起的，2-我接受的，3-pk中，4-已完成
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      pkList: []
    };
  },
  components: {
    Loading
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      console.log(n);
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getPkData();
      }
    }
  },
  methods: {
    getLKing(pk) {
      //获取左侧是否是winner
      if (pk.win_uid == pk.s_uid) {
        return "dp_pk_m";
      }
    },
    getRKing(pk) {
      if (pk.win_uid == pk.r_uid) {
        return "dp_pk_m";
      }
    },
    getLWidth(pk) {
      var lwidth;
      if (pk.s_salse == 0 && pk.r_salse == 0) {
        return 0;
      }
      console.log(pk.id + "-" + pk.r_salse + "," + pk.s_salse);
      lwidth =
        (parseInt(pk.s_salse) / (parseInt(pk.r_salse) + parseInt(pk.s_salse))) *
        100;
      console.log(lwidth);
      lwidth = lwidth.toFixed(2);
      return lwidth;
    },
    getLeftWidth(pk) {
      var lwidth = this.getLWidth(pk);
      return { width: lwidth + "%" };
    },
    getRightWidth(pk) {
      var lwidth = this.getLWidth(pk);
      var rwidth = 100 - lwidth;
      return { width: rwidth + "%" };
    },
    getChiptype(chip_type) {
      return chip_type == 0 ? "积分" : "金额";
    },
    getChip(pk) {
      var re = "";
      if (pk.chip_type == 0) {
        re = pk.chip + " 积分";
      } else {
        re = "￥ " + pk.chip + " 元";
      }
      return re;
    },
    getPkData() {
      getPkData().then(res => {
        this.pkData = res.data;
      });
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.pkList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit, type } = this;
      getPkUserList({
        page,
        limit,
        type
      }).then(res => {
        this.pkList = this.pkList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    delPk(pk) {
      cancelPkHandle(pk.id)
        .then(() => {
          this.pkList.splice(this.pkList.indexOf(pk), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    acceptTap: function(pk) {
      //接受PK
      acceptPkHandle(pk.id)
        .then(() => {
          this.pkList.splice(this.pkList.indexOf(pk), 1);
        })
        .catch(() => {
          this.reload();
        });
    }
  },
  mounted() {
    this.getPkData();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.dpvs {
  margin: 0 0.1rem;
  font-size: 0.4rem;
}
.dp_userpk .dp_pk_com_item {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 1.3rem;
}
.dp_userpk .dp_pk_com_des {
  text-align: left;
}
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
</style>
